.card {
  padding: 2rem;
  /* border: 0.8px solid #868989; */
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: auto;
  background-color: var(--white-color);
}

.passwordTitle {
  display: flex;
  flex-direction: column;
  margin-bottom: 1.25rem;
}

.input {
  position: relative;
  margin-bottom: 1rem;
}

.welcomeText {
  margin: 1.5rem 0 1rem 0;
  color: var(--gray-subtitle-color);
}

.errorMessage {
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;
  padding-left: 0.2rem;
  height: 10px;
}

.buttonsWrapper {
  display: flex;
  justify-content: space-between;
  margin: 1.5rem 0 1.5rem 0;
}

.backToLogin {
  margin-right: 1rem;
}


@media (max-width: 767.98px) {
  .inputs {
    min-height: 20vh;
    min-width: 70vw;
  }
}

@media (min-width: 768px) and (max-width: 1439.98px) {
  .inputs {
    min-height: 130px;
    min-width: 260px;
  }
}

@media (min-width: 1440px) and (max-width: 2559.98px) {
  .inputs {
    min-height: 160px;
    min-width: 330px;
  }
}

@media (min-width: 2560px) {
  .inputs {
    min-height: 190px;
    min-width: 420px;
  }
}
